import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

const defaultStyle = {
    color: 'var(--focus-color)',
    fontWeight: 'bolder',
    fontSize: '0.8rem',
    padding: '0.5rem 0',
    margin: 0,
    width: '100%'
}

const Wrapper = styled.div`
    width: 100%;
    display: flex;
    justify-content: center;
`

const Container = styled.div`
    width: ${props => props.style.width};
    color: ${props => props.style.color};
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    vertical-align: middle;
    padding: ${props => props.style.padding};
    margin: ${props => props.style.margin};
    font-weight: ${props => props.style.fontWeight};
    font-size: ${props => props.style.fontSize};
`

const Line = styled.div`
    width: 100%;
    border-bottom: ${props => '1px solid ' + props.color};
    margin: ${props => props.margin};
`

const Divider = props => {
    const {
        style,
        label
    } = props;
    let updatedStyle = Object.assign({}, defaultStyle, style)

    return (
        <Wrapper>
            <Container style={updatedStyle}>
                <Line color={updatedStyle.color} margin={'0 0.5rem 0 0 '}/>
                {label}
                <Line color={updatedStyle.color} margin={'0 0 0 0.5rem'}/>
            </Container>
        </Wrapper>
    )
}

export default Divider